import { Monitor, Search, MapPin, Store, Star, Sparkles, TrendingUp, Eye, BarChart3, Scale, Target, Route } from "lucide-react";
import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
const iconMap = {
  monitor: Monitor,
  search: Search,
  mapPin: MapPin,
  store: Store,
  star: Star,
  sparkles: Sparkles,
  scale: Scale,
  target: Target,
  route: Route
};
export function Areas() {
  const t = useT();
  return <section id="leistungen" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <div className="flex flex-wrap items-center gap-5 text-[11px] font-semibold tracking-[0.18em] text-[#94A3B8] uppercase">
            <span className="inline-flex items-center gap-2">
              <Eye size={15} aria-hidden style={{
              color: "#3B82F6"
            }} /> See
            </span>
            <span className="inline-flex items-center gap-2">
              <BarChart3 size={15} aria-hidden style={{
              color: "#3B82F6"
            }} /> Measure
            </span>
            <span className="inline-flex items-center gap-2">
              <TrendingUp size={15} aria-hidden style={{
              color: "#22C55E"
            }} /> Grow
            </span>
          </div>
          <h2 className="mt-6 text-2xl font-bold text-[#0F172A] sm:text-3xl">{t.areas.title}</h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#64748B]">{t.areas.lead}</p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {t.areas.items.map((area, i) => {
          const Icon = iconMap[area.icon];
          return <Reveal as="li" key={area.label} delay={i * 60}>
                <div className="relative h-full overflow-hidden rounded-2xl border border-black/5 bg-[#FAFBFC] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#60A5FA]/40 hover:shadow-[0_12px_32px_rgba(10,37,57,0.08)] motion-reduce:hover:translate-y-0">
                  <span aria-hidden className="absolute inset-x-0 top-0 h-[3px]" style={{
                backgroundImage: "linear-gradient(90deg,#3B82F6,#93C5FD)"
              }} />
                  <div className="flex items-start justify-between gap-4">
                    <Icon size={22} aria-hidden style={{
                  color: "#0F172A"
                }} strokeWidth={1.6} />
                    <span className="rounded-full bg-white px-2.5 py-1 text-[11px] font-semibold text-[#94A3B8]">
                      max. {area.max} Punkte
                    </span>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-[#0F172A]">{area.label}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">{area.line}</p>
                </div>
              </Reveal>;
        })}
        </ul>

        {t.areas.highlights && t.areas.highlights.length > 0 && <ul className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {t.areas.highlights.map((item, i) => {
          const Icon = iconMap[item.icon];
          return <Reveal as="li" key={item.label} delay={(t.areas.items.length + i) * 60}>
                  <div className="relative h-full overflow-hidden rounded-2xl border border-[#3B82F6]/10 bg-gradient-to-br from-[#FAFBFC] to-[#EFF6FF] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#60A5FA]/40 hover:shadow-[0_12px_32px_rgba(10,37,57,0.08)] motion-reduce:hover:translate-y-0">
                    <span aria-hidden className="absolute inset-y-0 left-0 w-[3px]" style={{
                backgroundImage: "linear-gradient(180deg,#3B82F6,#22C55E)"
              }} />
                    <div className="flex items-start gap-4">
                      <div className="rounded-lg bg-white p-2 shadow-sm">
                        <Icon size={20} aria-hidden style={{
                    color: "#3B82F6"
                  }} strokeWidth={1.6} />
                      </div>
                    </div>
                    <h3 className="mt-4 text-base font-semibold text-[#0F172A]">{item.label}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-[#64748B]">{item.line}</p>
                  </div>
                </Reveal>;
        })}
          </ul>}
      </div>
    </section>;
}